module.exports = __webpack_public_path__ + "img/diploma.0874fc05.svg";